import {
  Holder,
  Pic,
  Overlay,
  Caption,
  Text,
  Title,
  Mark,
  PicPivot,
  PicHolder
} from "./VisionariesSlide6.style"

import MarkIcon from "./mark.svg"

export default function VisionariesSlide6() {
  return (
    <Holder>
      <PicPivot>
        <PicHolder>
          <Pic src="/assets/textures/gallery/coronation_square/img-1c.jpg" />
          <Overlay>
            <Caption>
              <Title>
                Outerspace – Working Drawing <br />
                Landscape Architect
              </Title>
              <Text>
                Outerspace are award winning Landscape Architects and Urban
                Designers based in London.
              </Text>
              <Text>
                Working from a Grade II Listed boathouse on the Thames, they
                specialise in creative and sustainable placemaking and, wherever
                possible, engage local communities within the process.
              </Text>
              <Text>
                At the heart of everything Outerspace does is the promotion of a
                balance and connectivity in ‘human-nature’.  And so their
                innovative approach focuses on the unique relationship between
                people and the natural environment, resulting in well used
                spaces which are high in biodiversity.
              </Text>
              <Text>
                This approach is applied to create unique spaces to a range of
                scales; from holistic town centre regeneration strategies, to
                the implementation of prestigious public realm schemes,
                including public art and sculpture.
              </Text>
              <Mark src={MarkIcon}></Mark>
            </Caption>
          </Overlay>
        </PicHolder>
      </PicPivot>
    </Holder>
  )
}
